// extracted by mini-css-extract-plugin
module.exports = {"dropDownPosition":"StudentSwitchDropdown_dropDownPosition_3GoAu","profile-dropdown":"StudentSwitchDropdown_profile-dropdown_ZLIll"};